// Copyright (c) 2017 Deere & Company

import Modal from '../../shared/state/modal';
import actions from '../actions-list';
import {getDefaultState} from '../state';

const updateVisibility = (state, action) =>
    Modal.update(state, {
        isVisible: {
            $set: action.isVisible
        }
    });

export default (state = getDefaultState().statusChangeModal, action) => {

    const actionTypes = {
        [actions.UPDATE_PRODUCTS_BY_CUSTOMER_STATUS_CHANGE_MODAL_VISIBILITY]: updateVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/products-by-customer/reducers/status-change-modal.js